document.addEventListener('DOMContentLoaded', function() {
  // ferme le premier accordéon de chaque bloc accordéon
  document.querySelectorAll('.accordion').forEach(function(accordion) {
    const firstDetails = accordion.querySelector('details');
    if(firstDetails) firstDetails.removeAttribute('open');
  });
});